package com.picme

import com.lightningkite.kiteui.models.*


object Vectors {
    val logoWithWords = ImageVector(
        width = 3.rem,
        height = 3.rem,
        viewBoxMinX = 50,
        viewBoxMinY = 50,
        viewBoxWidth = 364,
        viewBoxHeight = 364,
        paths = listOf(
            ImageVector.Path(
                Color.black,
                path = "M164.881 235.401H151.08C149.94 235.401 149.181 234.641 149.181 233.502V151.201C149.181 150.062 149.94 149.302 151.08 149.302H163.615C164.754 149.302 165.514 150.062 165.514 151.201L165.767 158.038C169.946 151.581 176.53 147.783 186.026 147.783C203.372 147.783 215.401 161.964 215.401 180.323C215.401 198.809 203.372 212.863 186.026 212.863C177.543 212.863 171.085 209.571 166.78 204V233.502C166.78 234.641 166.021 235.401 164.881 235.401ZM182.354 163.736C172.985 163.736 166.527 170.32 166.527 180.323C166.527 190.326 172.985 196.91 182.354 196.91C191.47 196.91 198.308 190.326 198.308 180.323C198.308 170.447 191.47 163.736 182.354 163.736ZM248.472 128.537C248.472 133.981 244.42 138.286 238.849 138.286C233.278 138.286 229.099 133.981 229.099 128.537C229.099 123.219 233.278 118.914 238.849 118.914C244.42 118.914 248.472 123.219 248.472 128.537ZM231.885 211.344C230.745 211.344 229.986 210.584 229.986 209.445V151.201C229.986 150.062 230.745 149.302 231.885 149.302H245.686C246.826 149.302 247.585 150.062 247.585 151.201V209.445C247.585 210.584 246.826 211.344 245.686 211.344H231.885ZM318.714 201.721C313.396 208.558 304.913 212.863 294.91 212.863C276.044 212.863 262.116 198.682 262.116 180.07C262.116 161.71 275.918 147.783 294.53 147.783C304.786 147.783 313.269 152.088 318.587 158.925C319.347 159.811 319.094 160.824 318.334 161.584L310.737 169.054C309.724 170.067 308.331 169.94 307.445 169.054C304.026 165.635 300.354 163.863 295.29 163.863C285.414 163.863 278.956 170.953 278.956 180.07C278.956 189.186 285.414 196.783 295.67 196.783C300.481 196.783 304.153 195.01 307.572 191.592C308.458 190.705 309.851 190.579 310.864 191.592L318.461 199.062C319.22 199.822 319.474 200.835 318.714 201.721ZM165.395 324.375H151.196C150.013 324.375 149.224 323.586 149.224 322.403V261.93C149.224 260.747 150.013 259.958 151.196 259.958H164.869C166.052 259.958 166.841 260.484 166.841 262.061L167.235 268.897C170.785 262.85 176.569 258.38 185.377 258.38C193.659 258.38 200.101 262.324 203.651 269.818C207.2 263.244 213.51 258.38 223.502 258.38C237.305 258.38 245.719 267.846 245.719 284.673V322.403C245.719 323.586 244.93 324.375 243.747 324.375H229.549C228.366 324.375 227.577 323.586 227.577 322.403V288.617C227.577 279.809 224.422 275.076 217.323 275.076C210.487 275.076 206.543 279.809 206.543 288.617V322.403C206.543 323.586 205.754 324.375 204.571 324.375H190.504C189.19 324.375 188.401 323.586 188.401 322.403V288.617C188.401 279.809 185.114 275.076 178.147 275.076C171.31 275.076 167.367 279.809 167.367 288.617V322.403C167.367 323.586 166.578 324.375 165.395 324.375ZM318.756 317.802C313.234 323.323 304.952 325.953 295.881 325.953C274.715 325.953 260.517 311.36 260.517 291.904C260.517 272.973 273.795 258.38 293.646 258.38C313.234 258.38 324.54 272.841 324.54 289.143C324.54 295.453 323.094 299.003 317.441 299.003H278.265C280.237 307.153 286.941 311.623 297.327 311.623C302.323 311.623 307.055 310.703 312.314 307.679C313.234 307.153 313.891 307.285 314.549 308.205L319.413 314.91C320.07 315.83 319.939 316.75 318.756 317.802ZM293.777 273.367C285.758 273.367 279.579 277.705 278.002 286.251H308.37C307.318 277.705 301.534 273.367 293.777 273.367Z"
            ),
            ImageVector.Path(
                Color.bluePurpleGradient,
                path = "M183.039 68C183.039 65.7909 181.248 64 179.039 64H127.568C92.4602 64 64 92.4602 64 127.568V172.5C64 174.709 65.7909 176.5 68 176.5H84C86.2091 176.5 88 174.709 88 172.5V127.568C88 105.715 105.715 88 127.568 88H179.039C181.248 88 183.039 86.2091 183.039 84V68ZM293.276 88C291.067 88 289.276 86.2091 289.276 84V68C289.276 65.7909 291.067 64 293.276 64H316H336.432C371.54 64 400 92.4602 400 127.568V148V172.5C400 174.709 398.209 176.5 396 176.5H380C377.791 176.5 376 174.709 376 172.5V148V127.568C376 105.715 358.285 88 336.432 88H316H293.276ZM289.276 380C289.276 377.791 291.067 376 293.276 376H336.432C358.285 376 376 358.285 376 336.432V286.737C376 284.528 377.791 282.737 380 282.737H396C398.209 282.737 400 284.528 400 286.737V336.432C400 371.54 371.54 400 336.432 400H293.276C291.067 400 289.276 398.209 289.276 396V380ZM84 282.737C86.2091 282.737 88 284.528 88 286.737V336.432C88 358.285 105.715 376 127.568 376H179.039C181.248 376 183.039 377.791 183.039 380V396C183.039 398.209 181.248 400 179.039 400H127.568C92.4602 400 64 371.54 64 336.432V286.737C64 284.528 65.7909 282.737 68 282.737H84Z"
            ),
        )
    )
    val logoWithWordsDark = ImageVector(
        width = 3.rem,
        height = 3.rem,
        viewBoxMinX = 50,
        viewBoxMinY = 50,
        viewBoxWidth = 364,
        viewBoxHeight = 364,
        paths = listOf(
            ImageVector.Path(
                Color.white,
                path = "M164.881 235.401H151.08C149.94 235.401 149.181 234.641 149.181 233.502V151.201C149.181 150.062 149.94 149.302 151.08 149.302H163.615C164.754 149.302 165.514 150.062 165.514 151.201L165.767 158.038C169.946 151.581 176.53 147.783 186.026 147.783C203.372 147.783 215.401 161.964 215.401 180.323C215.401 198.809 203.372 212.863 186.026 212.863C177.543 212.863 171.085 209.571 166.78 204V233.502C166.78 234.641 166.021 235.401 164.881 235.401ZM182.354 163.736C172.985 163.736 166.527 170.32 166.527 180.323C166.527 190.326 172.985 196.91 182.354 196.91C191.47 196.91 198.308 190.326 198.308 180.323C198.308 170.447 191.47 163.736 182.354 163.736ZM248.472 128.537C248.472 133.981 244.42 138.286 238.849 138.286C233.278 138.286 229.099 133.981 229.099 128.537C229.099 123.219 233.278 118.914 238.849 118.914C244.42 118.914 248.472 123.219 248.472 128.537ZM231.885 211.344C230.745 211.344 229.986 210.584 229.986 209.445V151.201C229.986 150.062 230.745 149.302 231.885 149.302H245.686C246.826 149.302 247.585 150.062 247.585 151.201V209.445C247.585 210.584 246.826 211.344 245.686 211.344H231.885ZM318.714 201.721C313.396 208.558 304.913 212.863 294.91 212.863C276.044 212.863 262.116 198.682 262.116 180.07C262.116 161.71 275.918 147.783 294.53 147.783C304.786 147.783 313.269 152.088 318.587 158.925C319.347 159.811 319.094 160.824 318.334 161.584L310.737 169.054C309.724 170.067 308.331 169.94 307.445 169.054C304.026 165.635 300.354 163.863 295.29 163.863C285.414 163.863 278.956 170.953 278.956 180.07C278.956 189.186 285.414 196.783 295.67 196.783C300.481 196.783 304.153 195.01 307.572 191.592C308.458 190.705 309.851 190.579 310.864 191.592L318.461 199.062C319.22 199.822 319.474 200.835 318.714 201.721ZM165.395 324.375H151.196C150.013 324.375 149.224 323.586 149.224 322.403V261.93C149.224 260.747 150.013 259.958 151.196 259.958H164.869C166.052 259.958 166.841 260.484 166.841 262.061L167.235 268.897C170.785 262.85 176.569 258.38 185.377 258.38C193.659 258.38 200.101 262.324 203.651 269.818C207.2 263.244 213.51 258.38 223.502 258.38C237.305 258.38 245.719 267.846 245.719 284.673V322.403C245.719 323.586 244.93 324.375 243.747 324.375H229.549C228.366 324.375 227.577 323.586 227.577 322.403V288.617C227.577 279.809 224.422 275.076 217.323 275.076C210.487 275.076 206.543 279.809 206.543 288.617V322.403C206.543 323.586 205.754 324.375 204.571 324.375H190.504C189.19 324.375 188.401 323.586 188.401 322.403V288.617C188.401 279.809 185.114 275.076 178.147 275.076C171.31 275.076 167.367 279.809 167.367 288.617V322.403C167.367 323.586 166.578 324.375 165.395 324.375ZM318.756 317.802C313.234 323.323 304.952 325.953 295.881 325.953C274.715 325.953 260.517 311.36 260.517 291.904C260.517 272.973 273.795 258.38 293.646 258.38C313.234 258.38 324.54 272.841 324.54 289.143C324.54 295.453 323.094 299.003 317.441 299.003H278.265C280.237 307.153 286.941 311.623 297.327 311.623C302.323 311.623 307.055 310.703 312.314 307.679C313.234 307.153 313.891 307.285 314.549 308.205L319.413 314.91C320.07 315.83 319.939 316.75 318.756 317.802ZM293.777 273.367C285.758 273.367 279.579 277.705 278.002 286.251H308.37C307.318 277.705 301.534 273.367 293.777 273.367Z"
            ),
            ImageVector.Path(
                Color.white,
                path = "M183.039 68C183.039 65.7909 181.248 64 179.039 64H127.568C92.4602 64 64 92.4602 64 127.568V172.5C64 174.709 65.7909 176.5 68 176.5H84C86.2091 176.5 88 174.709 88 172.5V127.568C88 105.715 105.715 88 127.568 88H179.039C181.248 88 183.039 86.2091 183.039 84V68ZM293.276 88C291.067 88 289.276 86.2091 289.276 84V68C289.276 65.7909 291.067 64 293.276 64H316H336.432C371.54 64 400 92.4602 400 127.568V148V172.5C400 174.709 398.209 176.5 396 176.5H380C377.791 176.5 376 174.709 376 172.5V148V127.568C376 105.715 358.285 88 336.432 88H316H293.276ZM289.276 380C289.276 377.791 291.067 376 293.276 376H336.432C358.285 376 376 358.285 376 336.432V286.737C376 284.528 377.791 282.737 380 282.737H396C398.209 282.737 400 284.528 400 286.737V336.432C400 371.54 371.54 400 336.432 400H293.276C291.067 400 289.276 398.209 289.276 396V380ZM84 282.737C86.2091 282.737 88 284.528 88 286.737V336.432C88 358.285 105.715 376 127.568 376H179.039C181.248 376 183.039 377.791 183.039 380V396C183.039 398.209 181.248 400 179.039 400H127.568C92.4602 400 64 371.54 64 336.432V286.737C64 284.528 65.7909 282.737 68 282.737H84Z"
            ),
        )
    )

    val logoWithAdd = ImageVector(
        width = 24.dp,
        height = 24.dp,
        viewBoxMinX = 0,
        viewBoxMinY = 0,
        viewBoxWidth = 24,
        viewBoxHeight = 24,
        paths = listOf(
            ImageVector.Path(
                strokeWidth = 2.0,
                strokeCap = Icon.StrokeLineCap.Round,
                strokeColor = Color.darkPurple,
                path = "M9 2.5H6.5C4.29086 2.5 2.5 4.29086 2.5 6.5V9M15.25 2.5H17.5C19.7091 2.5 21.5 4.29086 21.5 6.5V9M2.5 15V17.5C2.5 19.7091 4.29086 21.5 6.5 21.5H9M21.5 15V17.5C21.5 19.7091 19.7091 21.5 17.5 21.5H15"
            ),
            ImageVector.Path(
                strokeWidth = 2.0,
                strokeCap = Icon.StrokeLineCap.Round,
                strokeColor = Color.darkPurple,
                path = "M12 8V16M8 12H16"
            )
        )
    )

    val apple = ImageVector(
        width = 24.dp,
        height = 24.dp,
        viewBoxMinX = 7,
        viewBoxMinY = 7,
        viewBoxWidth = 26,
        viewBoxHeight = 26,
        paths = listOf(
            ImageVector.Path(
                Color.black,
                path = "m19.8197,13.1385c1.0833,0 2.4412,-0.7324 3.2498,-1.7088 0.7324,-0.8849 1.2664,-2.1208 1.2664,-3.3566 0,-0.1678 -0.0153,-0.3357 -0.0458,-0.473 -1.2053,0.0458 -2.6548,0.8086 -3.5245,1.8309 -0.6866,0.7781 -1.3121,1.9987 -1.3121,3.2498 0,0.1831 0.0305,0.3662 0.0458,0.4272 0.0763,0.0153 0.1983,0.0305 0.3204,0.0305zM16.0053,31.6c1.48,0 2.136,-0.9917 3.9822,-0.9917 1.8767,0 2.2886,0.9612 3.9364,0.9612 1.6173,0 2.7006,-1.4952 3.7228,-2.9599 1.1443,-1.6783 1.6173,-3.3261 1.6478,-3.4024 -0.1068,-0.0305 -3.2041,-1.2969 -3.2041,-4.8519 0,-3.082 2.4412,-4.4704 2.5785,-4.5772 -1.6173,-2.3191 -4.0737,-2.3802 -4.7451,-2.3802 -1.8156,0 -3.2956,1.0985 -4.2263,1.0985 -1.007,0 -2.3344,-1.0375 -3.9059,-1.0375 -2.9905,0 -6.0267,2.4717 -6.0267,7.1405 0,2.8989 1.1291,5.9657 2.5175,7.9491C13.4726,30.2268 14.5101,31.6 16.0053,31.6Z"
            )

        )
    )

    val google = ImageVector(
        width = 24.dp,
        height = 24.dp,
        viewBoxMinX = 13,
        viewBoxMinY = 13,
        viewBoxWidth = 20,
        viewBoxHeight = 20,
        paths = listOf(
            ImageVector.Path(
                Color.fromHexString("4285f4"),
                path = "m31.64,23.2045c0,-0.6382 -0.0573,-1.2518 -0.1636,-1.8409L23,21.3636L23,24.845h4.8436C27.635,25.97 27.0009,26.9232 26.0477,27.5614v2.2582h2.9086C30.6582,28.2527 31.64,25.9455 31.64,23.2045Z"
            ),
            ImageVector.Path(
                Color.fromHexString("34a853"),
                path = "m23,32c2.43,0 4.4673,-0.8059 5.9564,-2.1805L26.0477,27.5614C25.2418,28.1014 24.2109,28.4205 23,28.4205 20.6559,28.4205 18.6718,26.8373 17.9641,24.71L14.9573,24.71v2.3318C16.4382,29.9832 19.4818,32 23,32Z"
            ),
            ImageVector.Path(
                Color.fromHexString("fbbc05"),
                path = "M17.9641,24.71C17.7841,24.17 17.6818,23.5932 17.6818,23c0,-0.5932 0.1023,-1.17 0.2823,-1.71L17.9641,18.9582L14.9573,18.9582C14.3477,20.1732 14,21.5477 14,23c0,1.4523 0.3477,2.8268 0.9573,4.0418z"
            ),
            ImageVector.Path(
                Color.fromHexString("ea4335"),
                path = "m23,17.5795c1.3214,0 2.5077,0.4541 3.4405,1.3459L29.0218,16.3441C27.4632,14.8918 25.4259,14 23,14 19.4818,14 16.4382,16.0168 14.9573,18.9582L17.9641,21.29C18.6718,19.1627 20.6559,17.5795 23,17.5795Z"
            ),
        )

    )

    val microsoft = ImageVector(
        width = 24.dp,
        height = 24.dp,
        viewBoxMinX = 0,
        viewBoxMinY = 0,
        viewBoxWidth = 21,
        viewBoxHeight = 21,
        paths = listOf(
            ImageVector.Path(Color.fromHexString("f25022"), path = "M1,1h9v9h-9z"),
            ImageVector.Path(Color.fromHexString("00a4ef"), path = "M1,11h9v9h-9z"),
            ImageVector.Path(Color.fromHexString("7fba00"), path = "M11,1h9v9h-9z"),
            ImageVector.Path(Color.fromHexString("ffb900"), path = "M11,11h9v9h-9z"),
        )
    )

}


val Icon.Companion.visibility
    get() = Icon(
        width = 2.rem,
        height = 2.rem,
        viewBoxMinX = 0,
        viewBoxMinY = -960,
        viewBoxWidth = 960,
        viewBoxHeight = 960,
        pathDatas = listOf("M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z")
    )


val Icon.Companion.visibilityOff
    get() = Icon(
        width = 2.rem,
        height = 2.rem,
        viewBoxMinX = 0,
        viewBoxMinY = -960,
        viewBoxWidth = 960,
        viewBoxHeight = 960,
        pathDatas = listOf("m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z")
    )

val Icon.Companion.generateRandomName
    get() = Icon(
        width = 1.5.rem,
        height = 1.5.rem,
        viewBoxMinX = 0,
        viewBoxMinY = -960,
        viewBoxWidth = 960,
        viewBoxHeight = 960,
        pathDatas = listOf("M160-160v-80h110l-16-14q-52-46-73-105t-21-119q0-111 66.5-197.5T400-790v84q-72 26-116 88.5T240-478q0 45 17 87.5t53 78.5l10 10v-98h80v240H160Zm400-10v-84q72-26 116-88.5T720-482q0-45-17-87.5T650-648l-10-10v98h-80v-240h240v80H690l16 14q49 49 71.5 106.5T800-482q0 111-66.5 197.5T560-170Z")
    )

val Resources.checkCircleUnSelected
    get() = ImageVector(
        width = 2.rem,
        height = 2.rem,
        viewBoxMinX = 0,
        viewBoxMinY = -960,
        viewBoxWidth = 960,
        viewBoxHeight = 960,
        paths = listOf(
            ImageVector.Path(
                fillColor = Color.white,
                path = "m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z",
            ),
        )
    )

val Resources.checkCircleSelected
    get() = ImageVector(
        width = 2.rem,
        height = 2.rem,
        viewBoxMinX = 0,
        viewBoxMinY = -960,
        viewBoxWidth = 960,
        viewBoxHeight = 960,
        paths = listOf(
            ImageVector.Path(
                fillColor = Color.bluePurpleGradient.applyAlpha(0.9f),
                path = "M480-480 m 424, 0 a 424,424 0 1,0 -848,0 a 424,424 0 1,0  848,0z",
            ),
            ImageVector.Path(
                fillColor = Color.white,
                path = "m424-296 282-282-56-56-226 226-114-114-56 56 170 170",
            ),
        )
    )

val Icon.Companion.imageStack
    get() = Icon(
        width = 1.5.rem,
        height = 1.5.rem,
        viewBoxMinX = 0,
        viewBoxMinY = 0,
        viewBoxWidth = 24,
        viewBoxHeight = 20,
        pathDatas = listOf(
            "M21.3 0H6.7C5.2 0 4 1.2 4 2.6v10.7C4 14.8 5.2 16 6.7 16h14.7c1.5 0 2.7-1.2 2.7-2.6V2.6C24 1.2 22.8 0 21.3 0zM8.4 4.2c.2-.3.6-.4.9-.4s.7.1.9.4.4.6.4.9-.1.7-.3.9-.6.4-1 .4-.7-.1-.9-.4-.4-.6-.4-.9.1-.7.4-.9zm12.2 8.3c-.2.3-.6.5-.9.5H8.3c-.4 0-.7-.2-.9-.6-.2-.3-.1-.8.1-1l2.7-3.3c.2-.2.5-.4.8-.4.3 0 .6.1.8.4l.7.9 2.3-3.5c.2-.3.5-.4.8-.4.3 0 .6.2.8.4l4 5.9c.3.4.3.8.2 1.1z",
            "M2 5c0-.5-.4-1-1-1s-1 .4-1 1v9.4C0 17.5 2.5 20 5.7 20H19c.6 0 1-.4 1-1 0-.5-.4-1-1-1H5.7c-2 0-3.7-1.6-3.7-3.6V5z"
        )
    )

val Icon.Companion.largeChevronLeft
    get() = Icon(
        3.rem,
        3.rem,
        0,
        -960,
        960,
        960,
        listOf("M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z")
    )